export default "__VITE_ASSET__38d468f3__"